// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import store from "@/store";
import App from "./App";
import router from "./router";
import "./directives";

import Meta from "vue-meta";
Vue.use(Meta);

import AtComponents from "at-ui";
import "at-ui-style";
Vue.use(AtComponents);

// Date time plugin
import Datetime from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
Vue.use(Datetime);

import "./assets/styles/base/_base.scss";
import "./assets/fonts/fontawesome/web/css/fontawesome-all.min.css";
import "./assets/fonts/font.iouu.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/animate.min.css";
import "./assets/css/loaders.min.css";
import "./assets/styles/iouu/_skin.scss";

import VueAnalytics from "vue-analytics";

Vue.use(VueAnalytics, {
  id: "UA-84567200-1",
});

Vue.config.productionTip = false;
const DashboardPlugins = {
  install(Vue) {
    Vue.prototype.$config = {
      investment: {
        minPercentToQueue: 100,
      },
      googleApi: {
        googleMapsKey: "AIzaSyC9YU8ifbsf9Ta6ZmpsVwIJfcXqKj4t_M8",
      },
    };
    const originalNotify = Vue.prototype.$Notify;
    const notificationTypes = ["success", "error", "warning", "info"];
    Vue.prototype.$Notify = {};

    notificationTypes.forEach((notificationType) => {
      Vue.prototype.$Notify[notificationType] = function(methodOptions) {
        let overridedOptions =
          typeof methodOptions == "string"
            ? { message: methodOptions }
            : methodOptions;
        overridedOptions = Object.assign({ duration: 5000 }, overridedOptions);
        originalNotify[notificationType](overridedOptions);
      };
    });
  },
};

Vue.use(DashboardPlugins);

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    Vue,
    dsn:
      "https://ed8982bade3d4868bb84d23e9547064e@o493101.ingest.sentry.io/5561553",
    autoSessionTracking: true,
    integrations: [new Integrations.BrowserTracing()],
    environment: "production",

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js